import SNAPPPAY_LOGO from "@website/accommodation-ui/hotel-snapppay-banner/assets/snapppay.png";
import { useLoginStatus } from "@website/hooks/auth-manager";
import { Button } from "@website/ui/button";
import { deepCompare } from "@website/utils/deep-compare";
import { useRouter } from "next/router";
import { FC, memo, useCallback } from "react";

const Component: FC<{ position?: "cityPage" | "hotelPage" }> = ({
  position
}) => {
  const router = useRouter();
  const { isLoggedIn } = useLoginStatus();

  const handleShowLoginModal = useCallback(
    () =>
      router.replace(
        {
          query: {
            ...router.query,
            login_step: "phone-number"
          }
        },
        undefined,
        { shallow: true, scroll: false }
      ),
    [router]
  );

  if (
    !["hotel-domestic", "villa"].includes(
      process.env.NEXT_PUBLIC_APP_NAME ?? ""
    ) ||
    isLoggedIn ||
    router.query.token
  )
    return null;

  return (
    <div className={position === "hotelPage" ? "w-full p-5 pb-0" : "w-full"}>
      <div className="border-ventures-fin-tech flex justify-between gap-1 rounded-lg border bg-[#008EFA12] px-2 py-3 lg:px-4">
        <div className="flex flex-col gap-1 font-medium">
          <div className="flex items-center gap-2">
            <img
              alt="snapp-pay-logo"
              className="size-6"
              src={SNAPPPAY_LOGO.src}
            />
            <h3 className="text-sm text-[#040A1FDE]">
              امکان پرداخت قسطی با اسنپ‌پی
            </h3>
          </div>
          <p className="text-caption text-[#040A1F99]">
            برای بررسی وضعیت اعتبار، وارد حساب کاربری شوید.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Button
            className="lg:px-5"
            color="secondary"
            onClick={handleShowLoginModal}
          >
            ورود
          </Button>
        </div>
      </div>
    </div>
  );
};

export const HotelSnapppayBanner = memo(Component, deepCompare);
